import React from 'react';
import Layout from '../../components/layout/layout';
import Hero from "../../components/hero/hero";
import Button from "../../components/button/button";

import MyCarousel from '../../components/carousel/carousel';

import styles from "./style.module.scss";
import { BASENAME } from "../../constant";
import { translate, translateValue } from '../../helper/functions';



export default function CarBody() {
    let responsive = {
        desktop: {
            breakpoint: { max: 5000, min: 1024 },
            items: 1

        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        }
    };

    const css = `
    .react-multi-carousel-dot-list {
        margin-bottom:5px;
    }
`

    return (
        <Layout>
            <style>{css}</style>
            <div className={styles.contentContainer}>
                <h1 className={styles.pageTitle}>{translate("AssistenzaCarrozzeriaTitolo")}</h1>
                <Hero
                    onlyBreadcrumb={true}
                    breadcrumb={[
                        { label: translate("AssistenzaCarrozzeriaPath01"), link: BASENAME },
                        { label: translate("AssistenzaCarrozzeriaPath02"), link: null },
                        { label: translate("AssistenzaCarrozzeriaPath03"), link: null }
                    ]}
                />

                <div className={styles.content}>
                    <div className="d-lg-none">
                        <img src="site_images/carrozzeria_new_logo_mobile.png" className="w-100" style={{ marginBottom: 24 }} />
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-7 pe-lg-5">
                            <div className={styles.contentText}>
                                <div className={styles.paragraph} dangerouslySetInnerHTML={{ __html: translate("AssistenzaCarrozzeria01Testo01") }} />

                                {translate("AssistenzaCarrozzeria01Testo02").split("|").map((el) => {
                                    return (
                                        <div className={styles.checkmarksContainer}>
                                            <img src="site_images/icon/icon_check.png" />
                                            <div>
                                                <h2>{el}</h2>
                                            </div>
                                        </div>
                                    )
                                })}


                                <div className={styles.paragraph} style={{ marginBottom: 0, marginTop: 20 }} dangerouslySetInnerHTML={{ __html: translate("AssistenzaCarrozzeria01Testo03") }} />
                                <div className="d-flex justify-content-center justify-content-lg-start">
                                    <Button
                                        label={translate("AssistenzaCarrozzeriaTel")}
                                        variation={"4"}
                                        style={{ marginBottom: 40, marginTop: 16, marginRight: 16 }}
                                        iconRight={["fas", "phone"]}
                                        onClick={() => window.open('tel:' + translate("AssistenzaCarrozzeriaTel"))}
                                    />
                                    <Button
                                        iconOnly={true}
                                        icon={["fab", "whatsapp"]}
                                        variation={"tertiary"}
                                        style={{ marginBottom: 40, marginTop: 16, width: 60 }}
                                        onClick={() => window.open('https://wa.me/message/6SDAOF2KJBZNE1')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-5 ps-lg-5 d-none d-lg-block">
                            <img src={translateValue("AssistenzaCarrozzeria01Img01")} className={styles.image} />
                        </div>
                    </div>
                </div>

            </div>

            <div className={styles.contentContainer} style={{ backgroundColor: "#D8DEE9", marginTop: 56 }}>
                <div className={styles.content}>
                    <div className={"d-block d-md-none"}>
                        <MyCarousel
                            responsive={responsive}
                            arrows={false}
                            showDots={false}
                            showDotsTablet={true}
                            showDotsMobile={true}
                        >
                            <div className={styles.serviceContent}>
                                <div className={styles.serviceTitleWithImage}>
                                    <img src="site_images/icon/Icon_Import-car.png" />
                                    <h2>{translate("AssistenzaCarrozzeria02Testo01")}</h2>
                                </div>
                                <p dangerouslySetInnerHTML={{ __html: translate("AssistenzaCarrozzeria02Testo02") }} />
                            </div>
                            <div className={styles.serviceContent}>
                                <div className={styles.serviceTitleWithImage}>
                                    <img src="site_images/icon/Icon_value_2.png" />
                                    <h2>{translate("AssistenzaCarrozzeria03Testo01")}</h2>
                                </div>
                                <p dangerouslySetInnerHTML={{ __html: translate("AssistenzaCarrozzeria03Testo02") }} />
                            </div>

                        </MyCarousel>

                    </div>

                    <div className="row justify-content-center d-none d-md-flex">
                        <div className="col-12 col-md-4">
                            <div className={styles.serviceContent}>
                                <div className={styles.serviceTitleWithImage}>
                                    <img src="site_images/icon/Icon_Import-car.png" />
                                    <h2>{translate("AssistenzaCarrozzeria02Testo01")}</h2>
                                </div>
                                <p dangerouslySetInnerHTML={{ __html: translate("AssistenzaCarrozzeria02Testo02") }} />
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className={styles.serviceContent}>
                                <div className={styles.serviceTitleWithImage}>
                                    <img src="site_images/icon/Icon_value_2.png" />
                                    <h2>{translate("AssistenzaCarrozzeria03Testo01")}</h2>
                                </div>
                                <p dangerouslySetInnerHTML={{ __html: translate("AssistenzaCarrozzeria03Testo02") }} />
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </Layout>
    );
}

